import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, TYPOGRAPHY, FONT_WEIGHT, COLORS } from '../../../styles/theme'

export const IntroBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs};
  margin-bottom: ${SPACING.xl};
`

export const IntroTitle = styled.div`
  font-size: ${TYPOGRAPHY.h4.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
`

export const IntroSubtitle = styled.div`
  font-size: ${TYPOGRAPHY.body.fontSize};
  color: var(--color-text-secondary);
  line-height: 1.5;
`

export const CategoryGroup = styled.div`
  margin-bottom: ${SPACING.xl};
`

export const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
  margin-bottom: ${SPACING.md};
`

export const CategoryDot = styled.span<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(p) => p.$color};
  flex-shrink: 0;
`

export const CategoryTitle = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--color-text-secondary);
`

export const NodeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm};
`

export const NodeRow = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.md};
  padding: ${SPACING.md} ${SPACING.lg};
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-left: 3px solid ${(p) => p.$color};
  border-radius: ${BORDER_RADIUS.md};
`

export const NodeLabel = styled.div`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-primary);
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
`

export const QuestionCountBadge = styled.span`
  flex-shrink: 0;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-secondary);
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border);
  border-radius: ${BORDER_RADIUS.full};
  padding: 2px ${SPACING.sm};
  white-space: nowrap;
`

export const EmptyCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.md};
  padding: ${SPACING.xxxl} ${SPACING.xl};
  border: 1px dashed var(--color-border);
  border-radius: ${BORDER_RADIUS.xl};
  background: var(--color-bg-card);
  text-align: center;
`

export const EmptyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: ${BORDER_RADIUS.full};
  background: ${COLORS.primary}14;
  color: ${COLORS.primary};
`

export const EmptyTitle = styled.div`
  font-size: ${TYPOGRAPHY.h4.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
`

export const EmptyText = styled.div`
  font-size: ${TYPOGRAPHY.body.fontSize};
  color: var(--color-text-secondary);
  line-height: 1.55;
  max-width: 460px;
`
